import React, { useState } from 'react'

import { cloneDeep } from 'lodash/lang'

const withState = WrappedComponent => {
  return props => {
    const {
      setCamperForm // via redux actions
    } = props

    const [formLoading, setFormLoading] = useState(true)

    const intialFormValues = {
      firstName: '',
      lastName: '',
      gender: '',
      birthdate: '',
      school: '',
      camperAllergies: [],
      hasDietaryRestrictions: false,
      hasFoodAllergies: false,
      hasNonFoodAllergies: false,
      foodAllergyNotes: '',
      nonFoodAllergyNotes: '',
      dietaryRestrictions: '',
      dietaryRestrictionsOther: '',
      medications: '',
      medicalConditions: '',
      immunizations: '',
      tetanusShotDate: null,
      parentNotes: '',
      doctorName: '',
      doctorPhoneNumber: '',
      sitsSeparately: null
    }

    if (formLoading) {
      setCamperForm(cloneDeep(intialFormValues))
      setFormLoading(false)
    }

    return <WrappedComponent formLoading={formLoading} {...props} />
  }
}

export default withState
